import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f41a783"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-military-green-500 pretitle" }, "Forgot Your"),
  /*#__PURE__*/_createElementVNode("h3", { class: "text-rust-500 lg:text-xl md:text-lg sm:text-sm" }, "Password?")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg break-words text-granite-gray" }, " Enter your email below and we'll send you a link to reset your password. ", -1))
const _hoisted_4 = { class: "controls" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Reset my password ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Cancel ")

import { ref } from 'vue';
import TextInputComponent from '../TextInputComponent.vue';
import Icon from '../icon/Icon';
import ButtonComponent from '@/components/ButtonComponent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordResetComponent',
  props: {
    error: { type: Boolean },
    submitMessage: null
  },
  emits: ['cancel', 'submit'],
  setup(__props: any) {



const email = ref('');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(TextInputComponent, {
      placeholder: "Email",
      "data-test-id": "email-input",
      textIcon: _unref(Icon).MAIL,
      value: email.value,
      class: "w-full mb-4",
      onInput: _cache[0] || (_cache[0] = ($event: any) => (email.value = $event))
    }, null, 8, ["textIcon", "value"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ButtonComponent, {
        "color-type": "secondary",
        "right-icon-value": _unref(Icon).ICON_FIELD_RIGHT,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit', email.value))),
        disabled: !email.value
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["right-icon-value", "disabled"]),
      _createVNode(ButtonComponent, {
        "color-type": "primary",
        size: "small",
        class: "md:justify-center",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    (__props.submitMessage)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["flex justify-center text-granite-gray", { 'text-red-600': __props.error }])
        }, _toDisplayString(__props.submitMessage), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})